import { analyticsServiceInitializer } from '@mgmresorts/web-analytics';

import { IdentityDigitalData } from './types';

const { AnalyticsServiceProvider, useAnalyticsService } = analyticsServiceInitializer<IdentityDigitalData>(
  {} as IdentityDigitalData,
);

export { AnalyticsServiceProvider, useAnalyticsService };
